"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _globals = require("@insided/shared/utils/globals");

var _userContext = require("../../server-middleware/userContext");

var _trackingLink = _interopRequireDefault(require("../link/tracking-link"));

var _TrackedCategoryMenu = require("./TrackedCategoryMenu");

var _getCategoryQuickLinks = require("./getCategoryQuickLinks");

var _common = require("@insided/shared/utils/common");

var isCustomDropdownsEnabled = _common.common.isModuleActive('customDropdowns');

var MegaMenuLink = function MegaMenuLink(_ref) {
  var _item$children;

  var item = _ref.item,
      parentProps = _ref.parentProps;

  if (item.key === 'community') {
    var communityCategoriesV2 = parentProps.communityCategoriesV2,
        openOnHover = parentProps.openOnHover,
        isHamburgerList = parentProps.isHamburgerList;

    if (communityCategoriesV2.length === 0) {
      return null;
    }

    return (0, _preact.h)(_userContext.CurrentUserContext.Consumer, null, function (user) {
      return (0, _preact.h)(_globals.ModulesContext.Consumer, null, function (modules) {
        return (0, _preact.h)(_TrackedCategoryMenu.TrackedCategoryMenu, {
          openOnHover: openOnHover,
          item: item,
          categoriesV2: communityCategoriesV2,
          popupName: "community-categories",
          quickLinks: (0, _getCategoryQuickLinks.getCategoryQuickLinks)(modules, user),
          isHamburgerList: isHamburgerList
        });
      });
    });
  }

  if (item.key === 'knowledgeBase') {
    var knowledgeBaseCategoriesV2 = parentProps.knowledgeBaseCategoriesV2,
        _openOnHover = parentProps.openOnHover,
        _isHamburgerList = parentProps.isHamburgerList;

    if (knowledgeBaseCategoriesV2.length === 0) {
      return null;
    }

    return (0, _preact.h)(_TrackedCategoryMenu.TrackedCategoryMenu, {
      openOnHover: _openOnHover,
      item: item,
      categoriesV2: knowledgeBaseCategoriesV2,
      popupName: "knowledgebase-categories",
      quickLinks: [{
        url: "".concat((0, _globals.getSubfolderPrefix)(), "/knowledge-base"),
        phrase: {
          m: 'Forum',
          p: 'nav.title.knowledgebase'
        }
      }],
      isHamburgerList: _isHamburgerList
    });
  }

  var isDropdown = !isCustomDropdownsEnabled || !!item.isDropdown; // Render the custom dropdown menu for custom links and custom dropdowns
  // Note: Unlike 'custom-link' key, 'custom' will only be used for external customization.

  if ((item.key === 'custom-link' && isCustomDropdownsEnabled && isDropdown || item.key === 'custom') && (_item$children = item.children) !== null && _item$children !== void 0 && _item$children.length) {
    var _item$children2;

    return (0, _preact.h)("li", {
      className: "header-navigation_list-item"
    }, (0, _preact.h)(_TrackedCategoryMenu.TrackedCategoryMenu, {
      openOnHover: false,
      item: item,
      categoriesV2: (_item$children2 = item.children) !== null && _item$children2 !== void 0 ? _item$children2 : [],
      popupName: "custom-categories",
      quickLinks: [],
      isHamburgerList: parentProps.isHamburgerList,
      isCustom: isCustomDropdownsEnabled && item.key === 'custom-link'
    }));
  }

  return (0, _preact.h)("li", {
    className: "header-navigation_list-item"
  }, (0, _preact.h)(_trackingLink.default, {
    track: {
      type: "Mega Menu click on ".concat(item.key, " module"),
      event_source: 'control'
    },
    className: "header-navigation_link title-".concat(item.name.split(' ').join('-').toLowerCase()),
    href: (0, _absoluteUrlRuntime.resolveUrl)(item.url),
    target: item.external ? '_blank' : '',
    rel: item.external ? 'noreferrer noopener' : ''
  }, item.name));
};

var _default = MegaMenuLink;
exports.default = _default;